import { AwsUi } from '../../../../core/runtime/src';
import LegacyClassBuilder from '../../../../core/utils/src/class-builders/legacy';
import { Button } from '../../../button/src';
import { Modal } from '../../../modal/src';
import PreferencesController from './controller';
import { getCollectionComponent, renderSafely } from '../utility';
export * from '../page-size-selector/index';
export * from '../content-selector/index';
export * from '../wrap-lines/index';
var _a = AwsUi.__addComponents(['awsui-table-preferences', 'awsui-cards-preferences'], {
    releaseStatus: 'stable',
    properties: {
        // Title of the preferences modal dialog.
        title: {
            type: 'string'
        },
        // Label of the confirm button in the modal footer.
        confirmLabel: {
            type: 'string'
        },
        // Label of the cancel button in the modal footer.
        cancelLabel: {
            type: 'string'
        },
        // If `true`, the preferences modal is disabled.
        disabled: {
            type: 'boolean',
            onChange: function () {
                if (this.disabled) {
                    this.__open = false;
                }
            }
        },
        __open: {
            type: 'boolean'
        }
    },
    regions: {
        // It contains all the preferences components. If you want to add custom content you need to wrap it
        // in one element and decorate it with className `awsui-table-custom-preference` if you are using
        // the Table component or `awsui-cards-custom-preference` if you are using Cards.
        preferences: {
            isDefault: true
        }
    },
    events: {
        // Fired when the user clicks on the confirm button in the preferences dialog.
        confirm: {
            bubbles: true,
            cancelable: false
        },
        // Fired when the user clicks on the cancel button in the preferences dialog.
        cancel: {
            bubbles: true,
            cancelable: false
        }
    },
    callbacks: {
        initialized: function () {
            this.__controller = new PreferencesController();
        },
        attached: function () {
            this.__parentComponent = getCollectionComponent(this.node);
            this.__parentComponent.__preferences = this;
        },
        detached: function () {
            if (this.__parentComponent) {
                this.__parentComponent.__preferences = null;
            }
        }
    },
    render: renderSafely(function (m, h) {
        var _this = this;
        var getComponentClassName = function (suffix) {
            return new LegacyClassBuilder(_this).addComponentClass(suffix).toClassName();
        };
        var onConfirm = function () {
            _this.__controller.confirm();
            _this.__fireEvent('confirm');
            _this.__open = false;
        };
        var onCancel = function () {
            _this.__controller.cancel();
            _this.__fireEvent('cancel');
            _this.__open = false;
        };
        var toggle = function () {
            _this.__open = !_this.__open;
        };
        var icon = function () {
            return (AwsUi.__createElement(Button, { className: getComponentClassName('trigger'), disabled: _this.disabled, label: _this.title, click: toggle, variant: "icon", icon: "settings", formAction: "none" }));
        };
        var modalFooter = function () {
            return (AwsUi.__createElement("div", { className: getComponentClassName('modal-footer') },
                AwsUi.__createElement(Button, { className: getComponentClassName('cancel-button'), text: _this.cancelLabel, click: onCancel, variant: "link", formAction: "none" }),
                AwsUi.__createElement(Button, { className: getComponentClassName('confirm-button'), text: _this.confirmLabel, click: onConfirm, variant: "primary", formAction: "none" })));
        };
        var modal = (AwsUi.__createElement(Modal, { header: AwsUi.__createElement("h2", { className: getComponentClassName('heading') }, this.title), visible: this.__open, dismiss: onCancel, closeLabel: this.cancelLabel, footer: modalFooter(), expandToFit: true, className: getComponentClassName('modal'), content: h.region('preferences', 'div', { className: getComponentClassName('region') }), size: "large" }));
        return (AwsUi.__createElement("div", null,
            icon(),
            modal));
    })
}), TablePreferences = _a[0], CardsPreferences = _a[1];
export { TablePreferences, CardsPreferences };
//# sourceMappingURL=index.js.map